import React, { FC, useEffect, useState } from 'react';

import { ImagesApp } from '../../../../constants/images';
import * as Style from './styles.dropDownMenu';

interface DropDownMenuProps {
  contentDropDown: React.ReactNode;
  prefixDropDown?: React.ReactNode;
  showArrow?: boolean;
}

const DropDownMenu: FC<DropDownMenuProps> = ({ contentDropDown, prefixDropDown, showArrow = true }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  const handleToggleMenu = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    if (isVisible) return setShouldRender(true);
    setTimeout(() => {
      setShouldRender(false);
    }, 180);
  }, [isVisible]);

  return (
    <Style.StyledDropDownMenu
      id="dropdown-menu-container"
      data-testid="dropdown-menu-container"
      onClick={handleToggleMenu}
    >
      {prefixDropDown} {showArrow && (
        <Style.StyledArrowIcon src={ImagesApp.svg.arrowDown} alt="arrow down" id="dropdown-arrow-icon" />
      )}
      <Style.StyledContentMenu $shouldRender={shouldRender} $isVisible={isVisible} id="dropdown-content-menu">
        {contentDropDown}
      </Style.StyledContentMenu>
    </Style.StyledDropDownMenu>
  );
};

export default DropDownMenu;
